import React from "react";
import { logout, getCurrentUser } from "../utils/authUtils";
import "./Header.css";

/**
 * @param {object} props
 * @param {() => void} props.onLogout
 * @param {() => void} props.onOpenSettings
 * @param {string} props.currentView - "main" or "settings"
 * @param {boolean} [props.sticky=true] - false lets the header scroll away, for a page
 *   that keeps its own bar pinned to the top instead
 */
const Header = ({ onLogout, onOpenSettings, currentView, sticky = true }) => {
  const currentUser = getCurrentUser();

  const handleLogout = () => {
    logout();
    onLogout();
  };

  // TEMPORARY FEATURE: Sample file download for development/demo purposes
  const handleDownloadSample = () => {
    try {
      const link = document.createElement("a");
      link.href = "/sample/sample.xlsx";
      link.download = "sample.xlsx";
      link.click();
      console.log("📄 Sample file download initiated");
    } catch (error) {
      console.error("❌ Error downloading sample file:", error);
      alert("Could not download sample file. Please ensure the file exists.");
    }
  };

  return (
    <header className={sticky ? "app-header" : "app-header app-header--static"}>
      <div className="header-content">
        <div className="title-container">
          <h1 className="app-title">Resource Allocation Manager</h1>
          <span className="by-company">BY BYTARION LTD.</span>
        </div>
        <div className="header-actions">
          <span className="welcome-text">Welcome, {currentUser}</span>
          {/* TEMPORARY FEATURE: Sample file download - subtle placement */}
          {currentView === "main" && (
            <button
              onClick={handleDownloadSample}
              className="sample-button"
              title="Download sample Excel file to try the app"
            >
              📄 Try Sample
            </button>
          )}
          {currentView === "main" && (
            <button onClick={onOpenSettings} className="settings-button">
              ⚙️ Settings
            </button>
          )}
          <button onClick={handleLogout} className="logout-button">
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
